import { AppBundle } from 'api/optimalprint-sdk.d';
import { cloneDeep } from 'lodash';

type Attribute = AppBundle.Api.Entity.App.V1.AbstractProduct.ProductItem.IAttribute;

export const getSpecifiedAttributes = (attributesToFilter: string[], attributes: Attribute[]) => {
  if (attributesToFilter.length === 0) {
    return [];
  }
  return attributes.filter((attribute) => attributesToFilter.indexOf(attribute.typeName) !== -1);
};

export const setAttributeValue = (attributesOriginal: Attribute[], typeName: string, value: string) => {
  const attributes = cloneDeep(attributesOriginal);
  const targetAttribute = attributes.find((attr) => attr.typeName === typeName);
  if (targetAttribute) {
    targetAttribute.value = value;
  } else {
    attributes.push({
      typeName,
      value,
    });
  }
  return attributes;
};

export const productMatchAttributes = (
  product: AppBundle.Api.Entity.App.V1.AbstractProduct.IProductItem,
  attributesToMatch: Attribute[],
) =>
  !attributesToMatch.some((attribute) => {
    const attrMatch = (product.attributes || []).find(
      (productAttribute) =>
        productAttribute.typeName === attribute.typeName && productAttribute.value === attribute.value,
    );
    return !attrMatch;
  });

export const filterProducts = (
  products: AppBundle.Api.Entity.App.V1.AbstractProduct.IProductItem[],
  attributesToFilter: Attribute[],
) => {
  if (attributesToFilter.length === 0) {
    return products;
  }
  return products.filter((productItem) => productMatchAttributes(productItem, attributesToFilter));
};

export const removeAttribute = (attributesOriginal: Attribute[], typeName: string) =>
  attributesOriginal.filter((attr) => attr.typeName !== typeName);
